import React, {useEffect, useState} from "react";
import PageTitle from "./include/PageTitle";
import {Link} from "react-router-dom";
import {get_services} from "../Utils/Data";
import Service from "./include/Service";
import {Helmet} from "react-helmet";

const Services = ({title}) => {
    const [services, setServices] = useState([]);


    useEffect(() => {
        const fetchServices = async () => {
            const data = await get_services();
             if(data){
            setServices(data);
            }
        };
        fetchServices()
    }, []);


    return (
        <>
            <Helmet>
                <title>Zaala | Services</title>
            </Helmet>
            <PageTitle title={title}/>


            <div className="services-two py-3 ">
                <div className="container">
                    <div className="section-title text-center tg-heading-subheading animation-style2">
                        <h5 className="tg-element-title" style={{perspective: 400}}>
                            <div
                                className="split-line"
                                style={{
                                    display: "block",
                                    textAlign: "center",
                                    position: "relative"
                                }}
                            >
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        u
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        r
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        s
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        r
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        v
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        i
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        c
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        s
                                    </div>
                                </div>
                            </div>
                        </h5>
                    </div>
                    <div className="row">
                        {/*Start Services One Single */}
                        <Service data={services}/>
                        {/*End Services One Single */}
                    </div>
                </div>
            </div>


        </>
    );
};

export default Services;
